import React, { useEffect, useState } from "react";
import SelectField from "../../../../../../global components/Forms/SelectField/SelectField";
import s from "./ModifyMember.module.scss";
import { Button } from "antd";
import clsx from "clsx";
import useSWR from "swr";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import {
  parseClientError,
  swrFetcher,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import {
  PaginatedTeamResponse,
  MemberData as UserData,
} from "../../../../../../libs/Utils/Types/Teams";
import { Roles } from "../../../../../../libs/Utils/Types/Teams";
import useSWRMutation from "swr/mutation";
import { SuccessDataType } from "../../../../../../libs/api/types";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
import Unauthorised from "../../../../../../global components/Unauthorised";
import { ThreeDots } from "react-loader-spinner";
type prop = {
  handleOpen: () => void;
  id: string;
};
function ModifyMemberForm({ handleOpen, id }: prop) {
  const token = UseAuthToken();
  const {
    data: teamMember,
    isLoading,
    error: memberError,
    mutate: mutateMember,
  } = useSWR<{ data: UserData }, any, any>(
    token ? [`api/admin/team/members/${id}`, token] : null,
    swrFetcher,
  );
  const [unauthorised, setUnauthorised] = useState<
    boolean | { title: string; message: string }
  >(false);

  const [searchValue /*setSearchValue*/] = useState("");
  const [currentPage /*setCurrentPage*/] = useState(1);
  const [pageItems /*setPageItems*/] = useState(10);
  const { data: roles, mutate:mutateRoles } = useSWR<{ data: Roles[] }, any, any>(
    token ? ["api/admin/team/roles", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );
  const [filter, setFilter] = useState<string>("");

  const { mutate: Mutate } = useSWR<PaginatedTeamResponse, any, any>(
    token
      ? [
          "api/admin/team/members",
          token,
          {
            page: currentPage,
            limit: pageItems,
            search: searchValue,
            ...(filter && { roleId: filter }),
          },
        ]
      : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );

  const { trigger: updateTeam, isMutating } = useSWRMutation(
    `api/admin/team/members/${id}/role`,
    swrMutationFetcher,
  );

  function handleFilter(value: string) {
    setFilter(value);
  }
  const updateMember = async () => {
    try {
      const fetchArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "PATCH",
          body: JSON.stringify({ roleId: filter }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await updateTeam(fetchArg);
      handleOpen();
      generateResult(
        "success",
        result.message.charAt(0).toUpperCase() + result.message.slice(1),
      );
      Mutate();
      mutateRoles()
      mutateMember();
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message || "Something went wrong");
    }
  };
  useEffect(() => {
    if (memberError) {
      const e = parseClientError(memberError);
      if (e.statusCode === 403) {
        setUnauthorised(true);
      } else {
        setUnauthorised({ title: "Error!", message: e.message });
      }
    }
  }, [memberError]);
  return isLoading ? (
    <div className={s.spin}>
      <ThreeDots
        visible={true}
        height="50"
        width="50"
        color="#d52b1e"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{
          dispaly: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
        wrapperClass=""
      />
    </div>
  ) : unauthorised ? (
    typeof unauthorised === "boolean" ? (
      <div className={s.spin}>
        <Unauthorised />
      </div>
    ) : (
      <div className={s.spin}>
        <Unauthorised error={unauthorised} />
      </div>
    )
  ) : (
    <div className={s.wrapper}>
      <div className={s.main}>
        <div className={s.userDetails}>
          <h3 className={s.userName}>
            {teamMember?.data.firstName + " " + teamMember?.data.lastName}
          </h3>
          <h4 className={s.email}>{teamMember?.data.email}</h4>
        </div>
        <div className={s.inputWrapper}>
          <h5 className={s.inputLabel}>Role</h5>
          <SelectField
            bordered
            defaultValue={teamMember?.data.role.id}
            label={"Role:"}
            wrapperClassname={s.SelectWrapper}
            onChange={(value: any) => handleFilter(value)}
            className={s.selectInput}
            style={{ width: "100%", height: "100%" }}
            options={roles?.data.map((role) => ({
              value: role.id,
              label: role.title,
            }))}
          />
        </div>
      </div>
      <div className={s.addContactBtns}>
        <Button
          type="default"
          className={clsx(s.button, s.cancelBtn)}
          onClick={handleOpen}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className={clsx(s.button, s.addContactBtn)}
          htmlType="submit"
          onClick={updateMember}
          loading={isMutating}
          disabled={isMutating}
        >
          Save changes
        </Button>
      </div>
    </div>
  );
}

export default ModifyMemberForm;
